var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8026",
    "data-name": "Group 8026",
    transform: "translate(-1310 -276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 24,
    height: 24,
    rx: 6,
    transform: "translate(1310 276)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    transform: "translate(845.795 -206.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M475.923,492.384a2.2,2.2,0,1,0-2.2-2.212A2.215,2.215,0,0,0,475.923,492.384Z",
    transform: "translate(0.276 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M478.224,491.834h-4.037a1.294,1.294,0,0,0-1.292,1.292v3.491a3.311,3.311,0,0,0,6.622.133v-3.637A1.291,1.291,0,0,0,478.224,491.834Z",
    transform: "translate(0 1.283)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedUserImage);
export default __webpack_public_path__ + "static/media/UnassignedUserImage.b674a616a1a8e2feca058988611ee1ad.svg";
export { ForwardRef as ReactComponent };